import { Navigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import AdminNavbar from "../navbar/AdminNavbar";
export default function AdminRoute({ children }) {
  const user = useAuth();

  if (!user) {
    return <Navigate to="/admin/login" />;
  } else if (user === "admin") {
    return (
      <>
        <AdminNavbar />
        {children}
      </>
    );
  } else if (user === "student") {
    return <Navigate to="/" />;
  }
}
